import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["poster", "width", "height", "autoplay", "loop", "muted"];
import { ref, computed, onMounted, watch, onBeforeUnmount } from "vue";
import Hls from "hls.js";
import AudioManager, { CHAPTER_MUSIC } from "@webgl/core/audio/AudioManager";
import useAudioManager from "@/composables/useAudioManager";
import useStoryChapters from "@/composables/useStoryChapters";
export default /*#__PURE__*/ _defineComponent({
    __name: 'UIVideo',
    props: {
        src: {},
        width: {},
        height: {},
        poster: {},
        autoplay: { type: Boolean },
        loop: { type: Boolean },
        muted: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const { muted: isMuted } = useAudioManager();
        const { currentChapter } = useStoryChapters();
        const player = ref(null);
        let hls;
        const isStream = computed(() => props.src.indexOf(".m3u8") !== -1);
        const muted = computed(() => props.muted || isMuted.value);
        const musicId = computed(() => CHAPTER_MUSIC[currentChapter.value]);
        async function onPlay() {
            await AudioManager.fadeOut(musicId.value);
            AudioManager.pause(musicId.value);
        }
        function onStop() {
            AudioManager.fadeIn(musicId.value);
        }
        watch(isMuted, (muted) => {
            const video = player.value;
            if (!video)
                return;
            video.muted = muted;
        }, { immediate: true });
        onMounted(() => {
            const video = player.value;
            if (!video)
                return;
            video.addEventListener("play", onPlay);
            video.addEventListener("pause", onStop);
            video.addEventListener("ended", onStop);
            // First check for native browser HLS support
            if (!isStream.value || video.canPlayType("application/vnd.apple.mpegurl")) {
                video.src = props.src;
                // If no native HLS support, check if HLS.js is supported
            }
            else if (Hls.isSupported()) {
                hls = new Hls({ backBufferLength: 30 });
                hls.loadSource(props.src);
                hls.attachMedia(video);
            }
        });
        onBeforeUnmount(() => {
            const video = player.value;
            if (!video)
                return;
            video.removeEventListener("play", onPlay);
            video.removeEventListener("pause", onStop);
            video.removeEventListener("ended", onStop);
            hls === null || hls === void 0 ? void 0 : hls.destroy();
            onStop();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("video", {
                ref_key: "player",
                ref: player,
                class: "size-full max-w-none object-cover",
                poster: _ctx.poster,
                width: _ctx.width,
                height: _ctx.height,
                autoplay: _ctx.autoplay,
                loop: _ctx.loop,
                muted: muted.value,
                playsinline: ""
            }, null, 8, _hoisted_1));
        };
    }
});
